import Modal from 'react-modal';
import { handleKeyDown } from '../../utils/utils';

type HelpAndContactModalProps = {
    isOpen?: boolean;
    onCloseModal: () => void;    
};

export default function HelpAndContactModal({isOpen = false, onCloseModal}: HelpAndContactModalProps) { 
    return(
        <Modal isOpen={isOpen} onRequestClose={onCloseModal}>
            <div className="modale open">
                
                <div className="modale--content">
                   
                <div className="modale--content--template">
               
                    <div className=" p-lg shadow-bleu m-y-xl bg-blanc " style={{maxHeight: "max-content", width: "90vw", maxWidth: "800px"}}>
                        <div className='modale--header pb-md'>
                            <p className='fz-lg fw-medium'>Besoin d'aide &#63;</p>
                            <i className="fz-xl" onClick={onCloseModal} role='button' tabIndex={0} onKeyDown={(e) => handleKeyDown(e)}>×</i>
                        </div>
                        <div className="">
                            <div className='m-y-lg'>
                                <p className='fz-lg'>Vous avez des questions particulières ? <strong>Parlez-nous-en.</strong></p>
                            </div>
                        
                            <div className="ta-center">
                                <a className="cta-bleu cta-small withicon m-sm" style={{border: "1px solid #144196"}} href="#"><i className="icon-question-reponse blanc"></i>FAQ</a>
                                <a className="cta-blanc cta-small withicon m-sm" style={{border: "1px solid #144196"}}><i className="icon-teleconseiller bleu"></i>Nous contacter</a>
                                
                            </div>                          
                        </div> 
                    </div>
                </div>
                </div>
            </div>
        </Modal>
    )
}